import {useRef} from 'react';
import {snippetService} from '../services/snippet.service';
import {toTitleCaseWords} from '../services/utils.service';

export function useFormEngagement(moduleName: string): (fieldName: string) => void {
	const hasReported = useRef(false);

	return (fieldName: string) => {
		if (hasReported.current) {
			return;
		}
		hasReported.current = true;
		snippetService.sendFormEngagementMessage(moduleName, toTitleCaseWords(fieldName));
	};
}
